import { render, staticRenderFns } from "./permissionManage.vue?vue&type=template&id=22ba6986&scoped=true&"
import script from "./permissionManage.vue?vue&type=script&lang=js&"
export * from "./permissionManage.vue?vue&type=script&lang=js&"
import style0 from "./permissionManage.vue?vue&type=style&index=0&id=22ba6986&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ba6986",
  null
  
)

export default component.exports